
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_n3x9d_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_n3x9d_1",
  "root": "awsui_root_mx3cw_n3x9d_119",
  "hidden": "awsui_hidden_mx3cw_n3x9d_135",
  "with-dismiss": "awsui_with-dismiss_mx3cw_n3x9d_158",
  "with-action": "awsui_with-action_mx3cw_n3x9d_158",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_n3x9d_164",
  "header": "awsui_header_mx3cw_n3x9d_171",
  "action": "awsui_action_mx3cw_n3x9d_175",
  "action-slot": "awsui_action-slot_mx3cw_n3x9d_180",
  "action-button": "awsui_action-button_mx3cw_n3x9d_181",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_n3x9d_185",
  "text": "awsui_text_mx3cw_n3x9d_211",
  "icon": "awsui_icon_mx3cw_n3x9d_216",
  "message": "awsui_message_mx3cw_n3x9d_219",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_n3x9d_227",
  "icon-size-big": "awsui_icon-size-big_mx3cw_n3x9d_230",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_n3x9d_233",
  "content": "awsui_content_mx3cw_n3x9d_237",
  "dismiss": "awsui_dismiss_mx3cw_n3x9d_241",
  "dismiss-button": "awsui_dismiss-button_mx3cw_n3x9d_246",
  "type-error": "awsui_type-error_mx3cw_n3x9d_250",
  "type-warning": "awsui_type-warning_mx3cw_n3x9d_258",
  "type-success": "awsui_type-success_mx3cw_n3x9d_266",
  "type-info": "awsui_type-info_mx3cw_n3x9d_274"
};
  